const Footer = () => {
  return (
    <footer
      className="bg-black text-zinc-600 text-xs border-t border-zinc-900 py-12"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="space-y-4">
          <h4 className="font-heading text-lg font-bold uppercase tracking-widest text-white">
            FAITH ATHLETIC
          </h4>
          <p className="text-zinc-500 font-light pr-4">
            Premium physical gear rooted in spiritual grit. Built on faith,
            driven by purpose.
          </p>
        </div>
        <div className="space-y-2">
          <h4 className="font-bold uppercase tracking-wider text-zinc-400">
            Customer Support
          </h4>
          <ul className="space-y-1">
            <li>
              <a href="#" className="hover:text-zinc-400 transition-colors">
                Shipping & Returns
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-zinc-400 transition-colors">
                Size Guides
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-zinc-400 transition-colors">
                Contact Us
              </a>
            </li>
          </ul>
        </div>
        <div className="space-y-2">
          <h4 className="font-bold uppercase tracking-wider text-zinc-400">
            Our Pillars
          </h4>
          <ul className="space-y-1">
            <li>
              <a href="#" className="hover:text-zinc-400 transition-colors">
                The @2027 Vision
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-zinc-400 transition-colors">
                Polynesian Roots Heritage
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-zinc-400 transition-colors">
                Athlete Sponsorships
              </a>
            </li>
          </ul>
        </div>
        <div className="space-y-4">
          <h4 className="font-bold uppercase tracking-wider text-zinc-400">
            Follow the Journey
          </h4>
          <div className="flex space-x-4 text-base text-zinc-400">
            <a href="#" className="hover:text-white" aria-label="Instagram">
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="#" className="hover:text-white" aria-label="TikTok">
              <i className="fa-brands fa-tiktok"></i>
            </a>
            <a href="#" className="hover:text-white" aria-label="YouTube">
              <i className="fa-brands fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 mt-12 pt-6 border-t border-zinc-900 text-center text-zinc-500 flex flex-col sm:flex-row justify-between items-center text-[10px] tracking-wider uppercase">
        <p>&copy; 2026 FAITH ATHLETIC CLOTHING LLC. ALL RIGHTS RESERVED.</p>
        <div className="flex space-x-4 mt-2 sm:mt-0">
          <a href="#" className="hover:underline">
            Privacy Policy
          </a>
          <a href="#" className="hover:underline">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
